import React, { useEffect, useState } from "react";
import { MenuItem, Select } from "@mui/material";
import { ValidateInput } from "../../utilities";
import "./style.css";

function CustomizedSelectDropdown(props) {
    const {
        label,
        liste_valeurs,
        name,
        required,
        error,
        schema,
        value: propValue
    } = props;

    const [state, setState] = useState(propValue || "");
    const [isValid, setIsValid] = useState(!error);

    const handleChange = (e) => {
        setState(e.target.value);
        const valid = ValidateInput(schema, { [name]: e.target.value });
        setIsValid(valid);
    };

    useEffect(() => {
        setState(propValue || "");
        setIsValid(!error);
    }, [propValue, error]);

    const options = liste_valeurs.split(";").filter(o => o.length > 0);

    return (
        <div className={`form-group form-element ${!isValid ? "error" : ""}`}>
            <label htmlFor={name}>
                {label} {required ? <span className='text-danger'>*</span> : null}
            </label>
            <Select
                name={name}
                id={name}
                className="form-control"
                value={state}
                onChange={handleChange}
            >
                {options.map((o, index) => (
                    <MenuItem
                        key={index}
                        value={o}
                        style={{ whiteSpace: 'pre-wrap', borderBottom: index !== options.length - 1 ? '1px solid #ccc' : '' }}
                    >
                        {o}
                    </MenuItem>
                ))}
            </Select>
        </div>
    );
}

export default CustomizedSelectDropdown;